import {
  AuthenticationState,
  initialAuthenticationState,
} from './authentication/authentication.state';
import { ErrorState, initialErrorState } from './error/error.state';
import { FightState, initialFightState } from './fight/fight.state';
import { FighterState, initialFighterState } from './fighter/fighter.state';
import { ImageState, initialImageState } from './image/image.state';
import { initialSeasonState, SeasonState } from './season/season.state';
import {
  initialSeasonFightsState,
  SeasonFightsState,
} from './seasonFights/seasonFights.state';
import { initialSidebarState, SidebarState } from './sidebar/sidebar.state';
import {
  initialTournamentState,
  TournamentState,
} from './tournament/tournament.state';
import { initialUserState, UserState } from './user/user.state';
import {
  initialUserSeasonState,
  UserSeasonState,
} from './userSeason/userSeason.state';
import {
  initialUserSeasonStatsState,
  UserSeasonStatsState,
} from './userSeason/userSeasonStats.state';

export interface AppState {
  fighters: FighterState;
  fights: FightState;
  sidebar: SidebarState;
  user: UserState;
  authentication: AuthenticationState;
  error: ErrorState;
  seasonFights: SeasonFightsState;
  season: SeasonState;
  userSeason: UserSeasonState;
  userSeasonStats: UserSeasonStatsState;
  tournament: TournamentState;
  image: ImageState;
}

export const initialState: AppState = {
  fighters: initialFighterState,
  fights: initialFightState,
  sidebar: initialSidebarState,
  user: initialUserState,
  authentication: initialAuthenticationState,
  error: initialErrorState,
  seasonFights: initialSeasonFightsState,
  season: initialSeasonState,
  userSeason: initialUserSeasonState,
  userSeasonStats: initialUserSeasonStatsState,
  tournament: initialTournamentState,
  image: initialImageState,
};
